<template>
  <div style="display: flex;justify-content: flex-start;margin: 0px 3px;flex-wrap: wrap">
    <span style="font-size: 12px;font-weight: bold">{{ title }}</span>
    <div v-for="(item,index) in dynamicChildren" :key="index" style="padding-right: 2px;font-size: 12px;">
      <div class="input-div" :style="{width:(item.text.length*5+25)+'px'}" v-text="item.text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmountSumMaster',
  props: {
    datafield: { type: String, default: '' },
    title: { type: String, default: () => { return this.$t('CargoMsg.Cargo_AmountToP') } },
    dataProvider: { type: Array, default: () => [] }
  },
  data() {
    return {
      data: [],
      currencyInUse: ['RMB', 'USD', 'HKD', 'EUR', 'GBP', 'JPY'],
      currencyUsed: [],
      dynamicChildren: [],
      useCurrencyORI: false // 是否使用原币种
    }
  },
  watch: {
    dataProvider(newVal) {
      this.setDataProvider(newVal)
    }
  },
  created() {
    this.onPreinitialize()
    this.setDataProvider(this.dataProvider)
  },
  methods: {
    onPreinitialize() {
      this.currencyUsed = []
      for (const c of this.currencyInUse) {
        this.currencyUsed.push({ currency: c, sum: 0 })
      }
    },
    setDataProvider(value) {
      let allCurrencyHasZeroSum = true
      this.dynamicChildren = []
      if (!value || value.length === 0) {
        return
      }
      this.data = value
      const _dataProvider = this.data
      if (this.datafield && this.datafield !== '') {
        for (const c of this.currencyUsed) {
          c.sum = NaN
        }
        for (const d of _dataProvider) {
          for (const c of this.currencyUsed) {
            if (isNaN(c.sum)) {
              if (d[this.datafield] !== 0) {
                c.sum = d[this.datafield]
              }
            } else {
              c.sum += d[this.datafield]
            }
            break
          }
        }
        for (const c of this.currencyUsed) {
          if (!isNaN(c.sum)) {
            this.addChildren(c)
            allCurrencyHasZeroSum = false
          }
        }
        if (allCurrencyHasZeroSum) {
          this.addChildrenForZeroSum()
        }
      }
    },
    addChildren(currency) {
      const ti = {}
      ti.text = currency.sum.toFixed(2)
      this.dynamicChildren.push(ti)
    },
    addChildrenForZeroSum() {
      const lbl = {}
      lbl.text = '0'
      this.dynamicChildren.push(lbl)
    }
  }

}
</script>

<style lang="scss" scoped>
.input-div{
  height: 25px;
  text-align: right;
  padding-right: 1px;
  font-style: italic;
}
</style>
